import React from "react";

interface Props {
  name: string;
  labelText: string;
  className?: string;
  items: Array<{ slug: string; title: string }>;
  activeQuery: string;
  handleOnChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.FC<Props> = ({
  handleOnChange,
  labelText,
  activeQuery,
  className = "",
  items,
  name,
}) => {
  return (
    <div className={className}>
      <label className="mr-4" htmlFor={name}>
        {labelText}
      </label>
      <select name={name} value={activeQuery} onChange={handleOnChange} className="select max-w-sm">
        {items.map((item) => (
          <option key={item.slug} value={item.slug || ""}>
            {item.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
